import { Response } from '@marketplace-web/core-api/api-client-util'

import { BumpOrderDto, BumpOrderModel, PrepareBumpOrderResp } from '../types/bump-order'

export const transformBumpUpOrder = (dto: BumpOrderDto): BumpOrderModel => ({
  id: dto.id,
})

export const transformPrepareBumpOrderResponse = (response: Response<PrepareBumpOrderResp>) =>
  transformBumpUpOrder(response.push_up_order)
